import { Pipe, PipeTransform } from '@angular/core';
import { AgilityRiskDateTimeService } from '../providers/agility-risk-datetime.service';

@Pipe({
  name: 'agilityDate'
})
export class AgilityDatePipe implements PipeTransform {
  constructor(private datetimeService: AgilityRiskDateTimeService) {
  }

  transform(value: Date, dateFormat?: string): unknown {
    return this.datetimeService.formatDate(value, dateFormat);
  }
}
